import { lazy, Suspense, type ComponentType, type ReactNode } from 'react';

interface DynamicOptions {
  loading?: ComponentType;
}

type Loader<TProps> = () => Promise<{ default: ComponentType<TProps> } | ComponentType<TProps>>;

export default function dynamic<TProps extends object>(
  loader: Loader<TProps>,
  options: DynamicOptions = {},
) {
  const LazyComponent = lazy(async () => {
    const mod = await loader();
    if ('default' in mod) return mod;
    return { default: mod };
  });

  return function DynamicComponent(props: TProps) {
    const Loading = options.loading;
    const fallback: ReactNode = Loading ? <Loading /> : null;
    return (
      <Suspense fallback={fallback}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
}
